import React from "react";
import ReactDOM from "react-dom/client";
import "./index.css";
import App from "./App";
import reportWebVitals from "./reportWebVitals";
import { ConfigProvider } from "antd";
import { RouterProvider, createBrowserRouter } from "react-router-dom";
import Login from "./Login";
import Error from "./Error";
import axiosInstance from "./axiosIntance";
import { registerChunkLoadRecovery, startVersionCheck } from "./utils/versionCheck";

const router = createBrowserRouter([
  {
    path: "/",
    element: <App />,
    loader: async () => {
      const response = await axiosInstance.get("/users/me");
      return {
        user: response.data.data,
      };
    },
  },
  {
    path: "/login",
    element: <Login />,
  },
  {
    path: "*",
    element: (
      <Error
        status="404"
        title="La page demandée n'existe pas."
        action={{
          on: () => (window.location.href = "/collections"),
          title: "Vers la page d'acceuil",
        }}
      />
    ),
  },
]);

registerChunkLoadRecovery();
startVersionCheck();

const root = ReactDOM.createRoot(
  document.getElementById("root") as HTMLElement
);

root.render(
  <React.StrictMode>
    <ConfigProvider
      theme={{
        token: {
          colorPrimary: "#001482",
          colorBgBase: "#ffffff",
          colorBgContainer: "#ffffff",
          colorLink: "#001482",
          colorLinkActive: "#001482",
          fontFamily: '"Questrial", sans-serif',
          fontFamilyCode: '"Montserrat", sans-serif',
        },
      }}
    >
      <RouterProvider router={router} />
    </ConfigProvider>
  </React.StrictMode>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
